import React from 'react';

export default function AccountCard({ account }) {
  return (
    <div className="card">
      <h3>{account.page_name || 'Facebook Page'}</h3>
      <p><strong>Page ID:</strong> {account.page_id || '—'}</p>
      <p><strong>Instagram:</strong> {account.ig_username || 'Not connected'}</p>
      {account.ig_id ? <p><strong>IG ID:</strong> {account.ig_id}</p> : null}
    </div>
  );
}
